import { render } from "./ImgLinkComponent.vue?vue&type=template&id=64c1295a&scoped=true"
import script from "./ImgLinkComponent.vue?vue&type=script&lang=js"
export * from "./ImgLinkComponent.vue?vue&type=script&lang=js"

import "./ImgLinkComponent.vue?vue&type=style&index=0&id=64c1295a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c1295a"]])

export default __exports__